import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Button, Stack } from '@lyearn/ui';
import { QuizPlayerActionsEnum } from '@/modules/corporate/modules/quiz/views/QuizPlayer/hooks/useQuizPlayer/actions';
import { RenderQuizPlayerQuestionActionParams } from '@/modules/corporate/modules/quiz/views/QuizPlayer/types';

interface InlineQuizNavigationActionsProps
  extends Pick<
    RenderQuizPlayerQuestionActionParams,
    'isFirstQuestion' | 'isLastQuestion' | 'onQuestionAction'
  > {
  onCancel: () => void;
}

function InlineQuizNavigationActions(props: InlineQuizNavigationActionsProps) {
  const { isFirstQuestion, isLastQuestion, onQuestionAction, onCancel } = props;
  const { t } = useTranslation();

  const onBack = () => {
    if (isFirstQuestion) {
      onCancel();
    } else {
      onQuestionAction(QuizPlayerActionsEnum.PrevQuestion);
    }
  };

  const onForward = () => {
    if (isLastQuestion) {
      onQuestionAction(QuizPlayerActionsEnum.SubmitQuestionAndSubmitQuiz);
    } else {
      onQuestionAction(QuizPlayerActionsEnum.NextQuestion);
    }
  };

  return (
    <Stack className="w-full" direction="row" gapX={8}>
      <Button variant="outlined" onClick={onBack}>
        {isFirstQuestion ? t('Common:Actions.Cancel') : t('Common:Actions.Previous')}
      </Button>
      <Button onClick={onForward}>
        {isLastQuestion ? t('Common:Actions.Submit') : t('Common:Actions.Next')}
      </Button>
    </Stack>
  );
}

export default InlineQuizNavigationActions;
